"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTableRows = void 0;
const typings_1 = require("../../TableCore/typings");
const dictionary_1 = require("../../TableCore/dictionary");
const getSortStringsUtil = (sortOrder, sortColumn) => (rowOne, rowTwo) => {
    const a = rowOne.group ? rowOne.mainRowData : rowOne;
    const b = rowTwo.group ? rowTwo.mainRowData : rowTwo;
    return sortOrder === typings_1.OrderTypeEnum.Ascending
        ? a[sortColumn].localeCompare(b[sortColumn])
        : b[sortColumn].localeCompare(a[sortColumn]);
};
const getSortDatesUtils = (sortOrder, sortColumn) => (rowOne, rowTwo) => {
    const a = rowOne.group ? rowOne.mainRowData : rowOne;
    const b = rowTwo.group ? rowTwo.mainRowData : rowTwo;
    let aTimestamp, bTimestamp;
    if (sortColumn === dictionary_1.tableDictionary.expirationDate) {
        aTimestamp = isFinite(a.expirationTimestamp) ? a.expirationTimestamp : 0;
        bTimestamp = isFinite(b.expirationTimestamp) ? b.expirationTimestamp : 0;
        return sortOrder === typings_1.OrderTypeEnum.Ascending
            ? aTimestamp - bTimestamp
            : bTimestamp - aTimestamp;
    }
    aTimestamp = isFinite(a.updatedTimestamp) ? a.updatedTimestamp : 0;
    bTimestamp = isFinite(b.updatedTimestamp) ? b.updatedTimestamp : 0;
    return sortOrder === typings_1.OrderTypeEnum.Ascending
        ? aTimestamp - bTimestamp
        : bTimestamp - aTimestamp;
};
const sortTableRows = (rows, sortOrder, sortColumn) => {
    const sortStrings = getSortStringsUtil(sortOrder, sortColumn);
    const sortDates = getSortDatesUtils(sortOrder, sortColumn);
    const isColumnWithSortingByDate = sortColumn === dictionary_1.tableDictionary.updated || sortColumn === dictionary_1.tableDictionary.expirationDate;
    return [...rows].sort(isColumnWithSortingByDate ? sortDates : sortStrings);
};
exports.sortTableRows = sortTableRows;
